import React from 'react';

import { CtaBox, CtaBoxActions, CtaBoxHeader } from 'components/cta-box';
import HeroImage from 'components/hero-image/hero-image';
import PageSection from 'components/page/page-section';
import { Header1 } from 'components/typography';
import P1 from 'components/typography/p-1';

type Props = {
  action: {
    onAppleStoreClick?: () => void;
    onGoogleStoreClick?: () => void;
    onClick?: () => void;
    href?: string;
    text: string;
  };
  title: string;
  subTitle: string;
  tooltipRight?: React.ReactNode;
  tooltipLeft?: React.ReactNode;
  image: {
    srcPortrait: string;
    objectPositionPortrait?: string;
    srcLandscape: string;
    objectPositionLandscape?: string;
    hasFrontFilter?: boolean;
    hasLoadPriority?: boolean;
  };
};

const PageSectionHeroSplash: React.FunctionComponent<Props> = ({
  image,
  title,
  subTitle,
  tooltipRight,
  tooltipLeft,
}) => {
  return (
    <PageSection>
      <HeroImage
        priority={image.hasLoadPriority}
        overlay={
          <div className="speech-box-wrapper">
            {tooltipRight ? (
              <div className="speech-box speech-box--right">{tooltipRight}</div>
            ) : null}
            <CtaBox>
              <CtaBoxHeader color="brand" tag="div">
                <Header1 color="brand" extraClass="is-title-header">
                  <h1>{title}</h1>
                </Header1>
              </CtaBoxHeader>
              <CtaBoxActions>
                <P1 color="brand">{subTitle}</P1>
              </CtaBoxActions>
            </CtaBox>
            {tooltipLeft ? <div className="speech-box speech-box--left">{tooltipLeft}</div> : null}
          </div>
        }
        imagePortrait={{
          src: image.srcPortrait,
          objectPosition: image.objectPositionPortrait,
        }}
        imageLandscape={{
          src: image.srcLandscape,
          objectPosition: image.objectPositionLandscape,
        }}
        hasFrontFilter={image.hasFrontFilter}
        aspectRatio={1440 / 889}
        isFullScreen={true}
      />
    </PageSection>
  );
};

export default PageSectionHeroSplash;
